export default Object.freeze({
  ADMIN: 'admin',
  MANAGER: 'manager',
  SPEAKER: 'speaker',
  MODERATOR: 'moderator',
  SPECTATOR: 'spectator'
})
